import { Controller } from "@hotwired/stimulus"

// Auto-scrolls the execution log container as Turbo Stream appends arrive.
// Disables auto-scroll when the user manually scrolls up (50px tolerance),
// re-enables when they scroll back to the bottom.
export default class extends Controller {
  static targets = ["log"]

  connect() {
    this.autoScroll = true
    this.scrollThreshold = 50

    // Watch for new children (Turbo Stream appends)
    this.observer = new MutationObserver(() => {
      if (this.autoScroll) {
        this.scrollToBottom()
      }
    })

    const logEl = this.hasLogTarget ? this.logTarget : this.element
    this.observer.observe(logEl, { childList: true, subtree: true })

    // Track user scroll to toggle auto-scroll
    this.element.addEventListener("scroll", this.handleScroll)

    // Initial scroll to bottom
    this.scrollToBottom()
  }

  disconnect() {
    this.observer?.disconnect()
    this.element.removeEventListener("scroll", this.handleScroll)
  }

  handleScroll = () => {
    const el = this.element
    const atBottom = el.scrollHeight - el.scrollTop - el.clientHeight < this.scrollThreshold
    this.autoScroll = atBottom
  }

  scrollToBottom() {
    requestAnimationFrame(() => {
      this.element.scrollTop = this.element.scrollHeight
    })
  }
}
